import { Injectable, Injector, inject } from '@angular/core';
import { LaboratoryName } from 'src/app/onboarding/lab/enums/lab.enum';
import { environment } from 'src/environments/environment';
import { OnboardingType } from '../../enums/intent.enum';
import { GeneralIntentStrategy } from './strategies/general-intent.strategy';
import {
  IntentStrategy,
  IntentStrategyContext,
} from './strategies/intent.strategy';
import { KitIntentStrategy } from './strategies/kit-intent.strategy';
import { LabIntentStrategy } from './strategies/lab-intent.strategy';
import { NiptIntentStrategy } from './strategies/nipt-intent.strategy';

@Injectable({ providedIn: 'root' })
export class IntentStrategyService {
  private injector = inject(Injector);

  public context!: IntentStrategyContext;

  constructor() {
    this.setStrategy(new GeneralIntentStrategy(this.injector));
  }

  public setStrategy(strategy: IntentStrategy) {
    this.context = new IntentStrategyContext(strategy);
  }

  public setStrategyByIntentId(intentId: string) {
    switch (intentId) {
      case environment.intents.adrialab: {
        this.setStrategy(
          new LabIntentStrategy(this.injector, LaboratoryName.ADRIA_LAB)
        );
        break;
      }
      case environment.intents.biolab: {
        this.setStrategy(
          new LabIntentStrategy(this.injector, LaboratoryName.BIO_LAB)
        );
        break;
      }
      case environment.intents.blood: {
        this.setStrategy(
          new KitIntentStrategy(this.injector, OnboardingType.BLOOD)
        );
        break;
      }
      case environment.intents.dna: {
        this.setStrategy(
          new KitIntentStrategy(this.injector, OnboardingType.DNA)
        );
        break;
      }
      case environment.intents.nipt: {
        this.setStrategy(new NiptIntentStrategy(this.injector));
        break;
      }
    }
  }

  public resetStrategy() {
    this.setStrategy(new GeneralIntentStrategy(this.injector));
  }
}
